// extracted by mini-css-extract-plugin
export default {"innerWrapper":"ys-z","tooltipWrapper":"zs-z","icon":"As-z","tooltip":"Bs-z","content":"Cs-z"};